<ng-container *ngIf="configEntries">
  <div *ngIf="showImageColumnTitles" class="d-flex">
    <p class="col-12 p-0 mb-3 text-title-s-bold">English images</p>
    <p class="col-12 p-0 mb-3 text-title-s-bold">Arabic images</p>
  </div>
  <div *ngFor="let config of configEntries" [class.vertical-layout]="layoutDirection === 'vertical'">
    <p *ngIf="showPlatformNames" class="text-title-s-bold mb-3">{{ config[0] }}</p>
    <div class="d-flex platform-images" [class.horizontal-layout]="layoutDirection === 'horizontal'">
      <osn-cxb-file-upload
        [formControl]="form.controls[config[0]].controls.en"
        [required]="required"
        [hasDeleteOption]="hasDeleteOption"
        [vm]="config[1].en"
        [isImageAlreadyBelongsToResource]="isImageAlreadyBelongsToResource"
        [shouldUploadPNG]="config[1].shouldUploadPNG"
        [verticalLayout]="layoutDirection === 'horizontal'"
      ></osn-cxb-file-upload>
      <osn-cxb-file-upload
        *ngIf="config[1].ar"
        [required]="required"
        [hasDeleteOption]="hasDeleteOption"
        [formControl]="form.controls[config[0]].controls.ar"
        [vm]="config[1].ar"
        [isImageAlreadyBelongsToResource]="isImageAlreadyBelongsToResource"
        [shouldUploadPNG]="config[1].shouldUploadPNG"
        [verticalLayout]="layoutDirection === 'horizontal'"
      ></osn-cxb-file-upload>
    </div>
  </div>
</ng-container>
